(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lora"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function(){


document.querySelectorAll(".dq-reviews-section").forEach(section=>{


const track = section.querySelector(".dq-review-track");

const cards = [...section.querySelectorAll(".dq-review-card")];

const next = section.querySelector(".dq-next");

const prev = section.querySelector(".dq-prev");



/* =========================
   REVIEW SLIDER
========================= */


if(track && cards.length){


let index = 0;


function isMobile(){

return window.innerWidth <= 640;

}



function moveSlider(){

let width = cards[0].offsetWidth + 18;

track.style.transform =
`translateX(-${index * width}px)`;

}



function nextSlide(){


if(isMobile()){


let max =
track.scrollWidth - track.clientWidth;


if(track.scrollLeft >= max - 10){

track.scrollTo({

left:0,

behavior:"smooth"

});


}else{


track.scrollBy({

left:cards[0].offsetWidth + 16,

behavior:"smooth"

});


}


return;

}



if(index >= cards.length - 3){

index = 0;

}else{

index++;

}


moveSlider();


}




function prevSlide(){


if(isMobile()){


track.scrollBy({

left:-(cards[0].offsetWidth + 16),

behavior:"smooth"

});


return;

}



index--;


if(index < 0){

index = 0;

}


moveSlider();


}



next?.addEventListener(
"click",
nextSlide
);



prev?.addEventListener(
"click",
prevSlide
);



let timer = setInterval(
nextSlide,
4500
);



section.addEventListener(
"mouseenter",
()=>clearInterval(timer)
);



section.addEventListener(
"mouseleave",
()=>{

timer=setInterval(
nextSlide,
4500
);

});



window.addEventListener(
"resize",
()=>{

index=0;

if(!isMobile()){

moveSlider();

}

});


}





/* =========================
 VIDEO POPUP
========================= */


const videoButtons =
section.querySelectorAll(".dq-video-play");



videoButtons.forEach(button=>{


button.addEventListener("click",function(e){


e.preventDefault();



const wrapper =
button.closest(".dq-video-review");



const video =
wrapper.querySelector("video");



const source =
video.querySelector("source").src;



if(!source) return;



const modal =
document.createElement("div");


modal.className="dq-video-modal";



modal.innerHTML=`

<div class="dq-video-popup">


<button class="dq-video-close">

×


</button>


<video 
controls
autoplay
playsinline
>


<source src="${source}" type="video/mp4">


</video>


</div>

`;



document.body.appendChild(modal);



const popupVideo =
modal.querySelector("video");



popupVideo.play();



function closeVideo(){


popupVideo.pause();

modal.remove();


}



modal.querySelector(".dq-video-close")
.addEventListener(
"click",
closeVideo
);



modal.addEventListener(
"click",
function(e){

if(e.target === modal){

closeVideo();

}

});


});


});





/* =========================
 INLINE VIDEO PLAY BUTTON
========================= */


const inlineVideos =
section.querySelectorAll(".dq-video-review");



inlineVideos.forEach(box=>{


const video =
box.querySelector("video");


const btn =
box.querySelector(".dq-video-play");



if(!video || !btn) return;



btn.addEventListener("click",()=>{


if(video.paused){


video.play();

btn.style.opacity="0";


}else{


video.pause();

btn.style.opacity="1";


}



});



video.addEventListener(
"ended",
()=>{

btn.style.opacity="1";

});



});



});

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
